import {FormControl, FormField} from 'platform/components';
import {Box} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {TASK_TYPES} from '../constants/TASK_TYPES';
import {DocumentExtractionImportFormDefinition} from '../types/DocumentExtractionImportFormDefinition';
import {DocumentExtractionImportFileField} from './DocumentExtractionImportFileField';

interface DocumentExtractionImportFormFieldsProps extends RequiredTestIdProps {
  control: FormControl<DocumentExtractionImportFormDefinition>;
  formApi: UseFormReturn<DocumentExtractionImportFormDefinition>;
}

export function DocumentExtractionImportFormFields(props: DocumentExtractionImportFormFieldsProps) {
  const files = useWatch({control: props.control, name: 'filesToImport'});
  const hasStructuredInvoice = files?.some((file) => file.sourceFormat === 'NISSAN_DIGLAS');

  return (
    <>
      <Box width="100%" data-testid={props['data-testid']}>
        <FormField
          isDisabled
          isRequired
          isNotClearable
          control={props.control}
          name="taskType"
          type="choice"
          label={i18n.t('entity.documentExtraction.labels.taskType')}
          options={hasStructuredInvoice ? structuredTaskTypeOptions : taskTypeOptions}
          data-testid={suffixTestId('inputs.taskType', props)}
        />
      </Box>
      <DocumentExtractionImportFileField
        name="filesToImport"
        control={props.control}
        formApi={props.formApi}
        data-testid={suffixTestId('inputs.filesToImport', props)}
      />
    </>
  );
}

const taskTypeOptions = [
  {
    label: i18n.t('entity.documentExtraction.labels.extractDeliveryNote'),
    value: TASK_TYPES.extractDeliveryNote,
  },
];

const structuredTaskTypeOptions = [
  {
    label: i18n.t('entity.documentExtraction.notifications.extractDocument'),
    value: TASK_TYPES.extractDeliveryNote,
  },
];
